import { render, staticRenderFns } from "./sysStudentIn.vue?vue&type=template&id=ed6805a2&"
import script from "./sysStudentIn.vue?vue&type=script&lang=js&"
export * from "./sysStudentIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports